import { initializer, inject, injectable } from "@launchtray/tsyringe-async";
import { Viewable, PromiseCompletionSource, SceneManager } from "scene-manager";
import { PreloaderResourcesPackage } from "./resources/PreloaderResourcesPackage";
import { PreloaderView } from "./views/PreloaderView";
import { PreloaderModel } from "./models/PreloaderModel";
import { ICanvasScaler } from "../../../canvas/ICanvasScaler";
import { PreloaderController } from "./controllers/PreloaderController";
import { InjectableInterfaces } from "../../composition/InjectableInterfaces";
import { GameSceneFactory, InjectableFactories } from "../../composition/InjectableFactories";
import { FullscreenBackground } from "../common/components/FullscreenBackground";

@injectable()
export class PreloaderScene extends Viewable<void> {

    public constructor(
        private readonly preloaderModel: PreloaderModel,
        private readonly sceneManager: SceneManager,
        @inject(InjectableInterfaces.ICanvasScaler) private readonly canvasScaler: ICanvasScaler,
        private readonly preloaderController: PreloaderController,
        @inject(InjectableFactories.GameSceneFactory) private readonly gameSceneFactory: GameSceneFactory,
        private readonly fullscreenBackground: FullscreenBackground
    ) {
        super();
    }

    @initializer()
    public async initialize(): Promise<void> {
        const preloaderResourcesPackage = await new PreloaderResourcesPackage().load() as PreloaderResourcesPackage;
        const viewCanBeClosed = new PromiseCompletionSource<void>();
        this.view = new PreloaderView(
            preloaderResourcesPackage,
            this.preloaderModel,
            this.preloaderController,
            this.canvasScaler,
            this.fullscreenBackground,
            viewCanBeClosed
        );
        viewCanBeClosed.result.then(async () => {
            const gameScene = await this.gameSceneFactory()
            this.sceneManager.showViewableAsync(gameScene);
            this.operationControls.complete();
        });
    }
}
